import React, {useContext} from "react";
import {Breadcrumb} from "antd";
import {AuthContext} from "../../config/AuthContext";
import {useNavigate} from "react-router-dom";

const AppBreadcrumb = () => {

    const {isLoggedIn, userId, user, breadcrumb} = useContext(AuthContext);
    const navigate = useNavigate();
    if (isLoggedIn) {
        return (
            <Breadcrumb style={{ margin: '16px 0' , cursor: 'pointer'}}>
                {breadcrumb.map((item: any, index) => (
                    <Breadcrumb.Item key={index} onClick={() => item.nav !== '' ? navigate(item.nav) : ''}>{item.nom}</Breadcrumb.Item>
                ))}
            </Breadcrumb>
        )
    } else {
        return (<></>)
    }
}

export default AppBreadcrumb;